import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Armchair, Check, Film } from "lucide-react";

export default function WatchPartyFull({ party, token, user }) {
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.includes("@")) return;
    try {
      await api.post(`/watch-party/${token}/waitlist`, { name: name.trim(), email: email.trim() });
      setSent(true);
    } catch { /* quiet in guest UI */ }
  };

  return (
    <div className="min-h-screen bg-ink grain flex items-center justify-center px-6" data-testid="wp-party-full">
      <div className="max-w-md w-full text-center">
        <Armchair className="w-14 h-14 mx-auto text-gold mb-4" />
        <h1 className="font-display text-3xl font-black mb-2">This party is full</h1>
        <p className="text-foreground/60 text-sm">
          All {party?.viewer_limit} seats in {party?.host_name || "the host"}&apos;s {party?.package_name || "Watch Party"} are taken.
          Ask the host for a seat, or start your own party.
        </p>
        {sent ? (
          <p className="mt-6 flex items-center justify-center gap-2 text-emerald-300 text-sm" data-testid="wp-full-waitlist-sent">
            <Check className="w-4 h-4" /> The host has been told you&apos;d like a seat.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-2 text-left">
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" className="bg-white/5 border-white/10" data-testid="wp-full-name" />
            <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" type="email" className="bg-white/5 border-white/10" data-testid="wp-full-email" />
            <Button type="submit" className="w-full bg-terracotta hover:bg-ember text-white" data-testid="wp-full-ask-seat">Ask the host for a seat</Button>
          </form>
        )}
        {party?.film_id && (
          <Link to={`/film/${party.film_id}`} className="mt-4 inline-flex items-center gap-2 text-sm text-gold hover:underline" data-testid="wp-full-own-party">
            <Film className="w-4 h-4" /> Host your own Watch Party
          </Link>
        )}
      </div>
    </div>
  );
}
